import React from 'react'
import "./Navbar.css"
import logo from '../../media/zlogo.png'
import { NavLink } from "react-router-dom";
export default function Navbar(props) {
  const css = {
    "--background": `${props.isValue ? props.mode : 'red'}`
  }
  return (
    <>
      <div className="phnLogo" style={{ color: `${props.isValue ? props.mode : 'red'}` }}>
        ZERONE
      </div>
      <div className="navbarContainer">
        <img src={logo} className='Z' alt="" />
        <div className="navbarComponent">
          <div className="logo">
            <div className="logoContainer" style={css}>
              <div className="logoDiv">
                ZERONE
              </div>
            </div>
          </div>
          <div className="list">
            <ul>
              <li><div className="listObj" id='home'><NavLink style={({ isActive }) => ({
                color: isActive ? `${props.isValue ? props.mode : 'red'}` : 'white'
              })}  to='/'><i className="fa-solid fa-house"></i><p>Home</p></NavLink></div></li>
              <li><div className="listObj"><NavLink style={({ isActive }) => ({
                color: isActive ? `${props.isValue ? props.mode : 'red'}` : 'white'
              })} to='/about'><i className="fa-solid fa-user"></i><p>About</p></NavLink></div></li>
              <li><div className="listObj"><NavLink style={({ isActive }) => ({
                color: isActive ? `${props.isValue ? props.mode : 'red'}` : 'white'
              })}  to='/project'><i className="fa-solid fa-bars-progress"></i><p>Projects</p></NavLink></div></li>
              <li><div className="listObj"><NavLink style={({ isActive }) => ({
                color: isActive ? `${props.isValue ? props.mode : 'red'}` : 'white'
              })} to='/blog'><i className="fa-solid fa-briefcase"></i><p>Blogs</p></NavLink></div></li>
              <li><div className="listObj"><NavLink style={({ isActive }) => ({
                color: isActive ? `${props.isValue ? props.mode : 'red'}` : 'white'
              })} to='/contact'><i className="fa-sharp fa-solid fa-comments"></i><p>Contact</p></NavLink></div></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
